import React from 'react'

function Github() {
  return (
    <div 
    style={{ width: "80%", margin: "auto" }}
    >
        <img
        src="https://ghchart.rshah.org/021F34/ashish123sharma"
        alt="fdsdf"
        style={{ width: "80%", display: "block", margin: "auto" }}
      />
    </div>
  )
}

export default Github